<template>
    <div class="layout-right">
        <div class="layout-right-top">
            <right-top bread="连锁管理-会员管理"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box search-box">
                <el-input v-model="searchData.keyword" placeholder="手机号/姓名首字母/姓名" style="width: 300px" />&nbsp;
                <el-select v-model="searchData.store_id" placeholder="请选择门店" clearable class="select">
                    <el-option label="所有门店" value=""></el-option>
                    <el-option
                            v-for="store in chainStoreArr"
                            :key="store.id"
                            :label="store.store_name"
                            :value="store.id">
                    </el-option>
                </el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                <!--<el-button>更改会员所属门店</el-button>-->
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil"
                    >
                        <el-table-column prop="nickname" label="姓名" min-width="90">
                            <template slot-scope="data">
                                <div class="nickname">
                                    {{data.row.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sex" label="性别" width="50">
                            <template slot-scope="data">
                                <span v-if="data.row.sex == 1">男</span>
                                <span v-else-if="data.row.sex == 2">女</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mobile" label="联系电话" width="110"></el-table-column>
                        <el-table-column prop="money" label="余额(元)" width="90"></el-table-column>
                        <el-table-column prop="vip_name" label="会员等级" width="80">
                            <template slot-scope="data">
                                {{data.row.vip_name ? data.row.vip_name : "无"}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="birthday_type" label="生日类型" width="80">
                            <template slot-scope="data">
                                {{data.row.birthday_type == "1" ? "公历" : (data.row.birthday_type == "2" ? "农历" : "")}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="birthday" label="生日日期" width="95"></el-table-column>
                        <el-table-column prop="create_datetime" label="加入时间" min-width="90"></el-table-column>
                        <el-table-column prop="last_cost_datetime" label="最后消费时间" min-width="90">
                            <template slot-scope="data">
                                <span v-if="data.row.last_cost_datetime">{{data.row.last_cost_datetime}}</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="store_name" label="所属门店" />
                    </el-table>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">
            <!--右下-->
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="slot, total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                        <div class="all-money">合计余额 {{allMoney}} 元，</div>
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import PopForm from "@/model/PopForm";
    import PayMoneyBox from "@/model/PayMoneyBox";
    import RightTop from "@/model/RightTop";
    export default {
        name: "StoreUserList",
        components: {
            RightTop, PayMoneyBox, PopForm, SearchBox, Menu},
        data: () => ({
            tableAttr:{
                width: "100%",
                height: "100%"
            },
            tableData: [],
            allMoney: "0.00",
            page: {
                nowPage: 1,
                pageSize: 20,
                pageSizes: [20, 50, 100, 200],
                count: 0,
            },
            postData: {},
            searchData: {
                keyword: "",
                store_id: ""
            },
            chainStoreArr: [],

            vip_list: []
        }),
        mounted: function(){
            this.$store.commit("setMenuId", "14-4");

            this.loadChainStore();
            this.loadListData();

        },
        methods: {
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //加载所有门店
            ,loadChainStore: function () {
                this.$root.postData("chain/get_child_store_list_short", {}, res => {
                    if(res.errcode === 0){
                        this.chainStoreArr = res.data;
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            }

            //加载列表数据
            ,loadListData: function () {
                this.postData = Object.assign(this.postData, {
                    offset: this.page.pageSize * (this.page.nowPage - 1),
                    limit: this.page.pageSize
                });
                this.$root.postData("chain/get_store_user_list", this.postData, res => {
                    if(res.errcode === 0){
                        this.tableData = res.data.user_list;
                        this.page.count = res.data.count;
                        this.allMoney = res.data.all_money;
                    }else{
                        this.tableData = [];
                    }
                });
            }

            //搜索事件
            ,searchEvent: function () {
                this.postData.keyword = this.searchData.keyword ? this.searchData.keyword : "";
                this.postData.search_store_id = this.searchData.store_id ? this.searchData.store_id : "";
                this.loadListData();
            }

        }
    }
</script>

<style scoped>
    .layout-right{
        /*min-width: 1180px;*/
    }
    .layout-right-body>.search-box{
        padding: 16px;
    }
    .layout-right-body>.item-content>.table-box{
        border-bottom: none;
        background-color: #ffffff;
        overflow:hidden;
        padding: 5px 16px 0;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-top: 1px solid #ebedf0;
    }
    .layout-right-bottom{
        padding-top: 0px;
    }
    .all-money{
        display: inline-block;
        font-weight: normal;
        font-size: 13px;
        line-height: 28px;
        color: #606266;
    }
    .table-box .nickname{
        padding: 10px 0;
    }
</style>
